import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import AccountIcon from '@material-ui/icons/AccountCircle';
import Radio from '@material-ui/core/Radio';

// Currently being used for invitation dialog only

export default function UserSearchListRadio(props) {

    const [ searchValue, setSearchValue ] = useState("");
    const [ filteredGuests, setFilteredGuests ] = useState([]);
    const { guests, selected, onSelect, label, invitation } = props;

    useEffect(() => {
        setFilteredGuests(guests);
    }, [guests]);

    const handleSearchValue = event => {
        event.preventDefault();

        const newSearchValue = event.target.value

        let newFilteredGuests = guests.filter((d) => {
            let match = false;
            if (d.full_name !== null) {
                let m = d.full_name.toLowerCase().includes(newSearchValue.toLowerCase());
                if (m) match = true;
            }
            return match;
        })

        setFilteredGuests(newFilteredGuests);
        setSearchValue(newSearchValue);
    };

    const hasBeenSent = (guest_id) => {
        if (invitation) return invitation.guest.invitations_sent.find(i => i.guest_id === guest_id) ? true : false;
        return false;
    }

    return (
        <Fragment>
            <div>
                <input autoComplete="false" name="hidden" type="text" style={{ display: 'none' }}/>
                <TextField
                    id="users-search"
                    label={label}
                    type="search"
                    margin="normal"
                    variant="outlined"
                    value={searchValue}
                    fullWidth
                    onChange={handleSearchValue}
                />
            </div>
            <List>
                {filteredGuests.map((guest, index) => (
                    <ListItem
                        key={guest.id}
                        button
                        onClick={() => onSelect(guest.id)}
                        disabled={hasBeenSent(guest.id)}
                        >
                        <ListItemAvatar>
                            <Avatar
                                alt={guest.full_name}
                                src={guest.avatar ? guest.avatar.full_url : null}
                                >
                                <AccountIcon fontSize='inherit' />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={guest.full_name}
                            secondary={hasBeenSent(guest.id) ?'Invitation Sent' : null}
                        />
                        <ListItemSecondaryAction>
                            <Radio
                                checked={selected == guest.id}
                                onChange={() => onSelect(guest.id)}
                                value={guest.id}
                                name="user-select"
                                color="primary"
                                disabled={hasBeenSent(guest.id)}
                              />
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        </Fragment>
    )
}
